import React, { useEffect, useState } from "react"
import styled from "styled-components"
import Overlay from "../../../../../ProjectNonSpecificComponents/Elements/Overlay/Overlay"
import { TOnClick } from "../../../../Interfaces/GlobalInterface"
import H2 from "../../atoms/Text/H2"
import SepLine from "../../atoms/SepLine"
import IconButton from "../../atoms/Buttons/IconButton"
import useScreenType from "components/ProjectNonSpecificComponents/Hooks/useScreenType"
import Whitespace from "components/ProjectNonSpecificComponents/Elements/Whitespace"

interface Props {
	/** If title is not supplied, SepLine is not shown */
	width?: string
	title?: string
	children?: React.ReactNode
	onClose?: TOnClick<HTMLButtonElement | HTMLElement>
	btnColor?: string
	isTransparant?: boolean
	top?: string
	left?: string
}

const ModalWithSepLine = ({
	title,
	children,
	onClose = () => {},
	btnColor,
	width = "800px",
	isTransparant = false,
	top,
	left,
}: Props) => {
	const { isMobile } = useScreenType()
	const [show, setShow] = useState(false)
	useEffect(() => {
		setShow(true)
	}, [])

	const onOuterClickFn = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
		if (isTransparant) return

		if (e.currentTarget != e.target) return
		onClose(e)
	}

	return (
		<div className={isTransparant ? "" : "blur-bg-overlay"} onClick={onOuterClickFn}>
			<Overlay
				screenCentered={isTransparant ? false : true}
				top={isTransparant ? top : undefined}
				left={isTransparant ? left : undefined}
				className={isTransparant ? "bottom-overlay" : ""}
			>
				<BaseContainer
					className="flex-col"
					style={{
						width: isMobile ? "100vw" : width,
						padding: "16px 24px",
						borderRadius: isMobile ? "" : "10px",
						...(show
							? {
									transform: "translateY(0%)",
									opacity: 1,
							  }
							: {}),
					}}
				>
					<div className="absolute" style={{ top: "1em", right: "1em" }}>
						<IconButton
							iconKey="cross"
							onClick={onClose}
							iconColor={btnColor}
							iconColorOnHover={btnColor}
						/>
					</div>

					{title ? (
						<>
							<ModalHeader className="center-x-y">
								<H2>{title}</H2>
							</ModalHeader>
							<SepLine />
						</>
					) : (
						<Whitespace x="2" />
					)}
					<ContentContainer className="font-size-18">{children}</ContentContainer>
				</BaseContainer>
			</Overlay>
		</div>
	)
}

export default ModalWithSepLine

const BaseContainer = styled.div`
	max-height: 80vh;
	background-color: var(--white);
	box-shadow: var(--default-box-shadow);
	transform: translateY(1.6rem);

	// Animation
	opacity: 0;
	transition: 0.2s var(--default-slide-transition-fn);
	transition-property: opacity, transform;
`

const ModalHeader = styled.div`
	height: 50px;
`

const ContentContainer = styled.div`
	overflow: hidden;
	overflow-y: auto;
`
